import {
  LIST_EXPORT_TRANSACTION_REQUEST,
  LIST_EXPORT_TRANSACTION_SUCCESS,
  LIST_EXPORT_TRANSACTION_FAIL,
  DOWNLOAD_EXPORT_TRANSACTION_REQUEST,
  DOWNLOAD_EXPORT_TRANSACTION_SUCCESS,
  DOWNLOAD_EXPORT_TRANSACTION_FAIL,
  EXPORT_EXPORT_TRANSACTION_REQUEST,
  EXPORT_EXPORT_TRANSACTION_SUCCESS,
  EXPORT_EXPORT_TRANSACTION_FAIL
} from '../../../constants/exports/export-transaction'

const initialState = {
  loading: false,
  loadingExportTransactionDownload: false,
  loadingExportTransactionExport: false,
  exportTransaction: [],
  exportTransactionDetail: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const listExportTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_EXPORT_TRANSACTION_REQUEST:
      return { ...state, loading: true }
    case LIST_EXPORT_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        exportTransaction: action.payload,
        pageable: action.pageable
      }
    case LIST_EXPORT_TRANSACTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        exportTransaction: action?.dummy
      }
    case DOWNLOAD_EXPORT_TRANSACTION_REQUEST:
      return { ...state, loadingExportTransactionDownload: true }
    case DOWNLOAD_EXPORT_TRANSACTION_SUCCESS:
      return {
        ...state,
        loadingExportTransactionDownload: false,
        exportTransactionDetail: action.payload,
        pageable: state.pageable
      }
    case DOWNLOAD_EXPORT_TRANSACTION_FAIL:
      return {
        ...state,
        loadingExportTransactionDownload: false,
        error: action.payload
      }
    case EXPORT_EXPORT_TRANSACTION_REQUEST:
      return { ...state, loadingExportTransactionExport: true, error: null }
    case EXPORT_EXPORT_TRANSACTION_SUCCESS:
      return {
        ...state,
        loadingExportTransactionExport: false,
        error: null
      }
    case EXPORT_EXPORT_TRANSACTION_FAIL:
      return {
        ...state,
        loadingExportTransactionExport: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default listExportTransactionReducer
